import { NgModule } from '@angular/core';
import {TourMatMenuModule} from 'ngx-ui-tour-md-menu';
import { SettingsComponent } from './components/settings.component';
import { AdminModule } from '@src/app/layout/admin/admin.module';
import { SettingsRoutingModule } from './settings-routing.module';
import { OrganisationSettingsComponent } from './components/organisation-settings/organisation-settings.component';
import { FileDragNDropDirective } from './directives/file-drag-n-drop.directive';
import { RolesComponent } from './components/roles/roles.component';
import { RoleEditComponent } from './components/role-edit/role-edit.component';
import { CreditLogsComponent } from './components/credit-logs/credit-logs.component';
import { SystemSettingsComponent } from './components/system-settings/system-settings.component';
import { MatListModule } from '@angular/material/list';

@NgModule({
    imports: [
        AdminModule,
        SettingsRoutingModule,
		TourMatMenuModule,
        MatListModule,
    ],
	declarations: [
		SettingsComponent,
		OrganisationSettingsComponent,
		RolesComponent,
		RoleEditComponent,
		FileDragNDropDirective,
		CreditLogsComponent,
        SystemSettingsComponent
	],
	exports: [
		SettingsComponent,
		OrganisationSettingsComponent,
		RolesComponent,
		RoleEditComponent,
		CreditLogsComponent,
		SystemSettingsComponent,
		FileDragNDropDirective
	]
})
export class SettingsModule { }
